const styles = (theme) => ({
  thumbsContainer: {
    width: '100%',
  },
  fieldContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing.unit * 2,
    border: `1px dashed ${theme.palette.border.light}`,
    padding: `0 ${theme.spacing.unit * 2}px`,
    minHeight: 110,
    height: 109, // Fixes IE 11 flexbox issue https://github.com/philipwalton/flexbugs/issues/231.
    [theme.breakpoints.up('xl')]: {
      minHeight: 200,
    },
  },
  fieldContainerWithFile: {
    [theme.breakpoints.up('xl')]: {
      minHeight: 402,
    },
  },
  progress: {
    marginTop: theme.spacing.unit * 2,
  },
  photoCard: {
    marginTop: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  thumb: {
    maxWidth: '100%',
    textAlign: 'center',
    '&&': {
      paddingBottom: theme.spacing.unit * 1.5,
    },
  },
  thumbInner: {
    height: 230,
    maxWidth: 265,
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 315,
      maxWidth: 350,
    },
  },
  img: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    fontFamily: "'object-fit: cover;'", // Needed for IE11, old Edge, Safari..
  },
  hidden: {
    display: 'none',
  },
  buttonContainer: {
    paddingBottom: theme.spacing.unit,
    maxWidth: '100%',
  },
  removeAction: {
    display: 'block',
    margin: '2px auto 0',
  },
  errorIcon: {
    color: theme.palette.primary.dark,
    fontSize: '2rem',
  },
  previewDialog: {
    maxWidth: 'none',
    minWidth: 0,
    overflowY: 'visible',
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px`,
    fontSize: 0,
  },
  previewImageContainer: {
    display: 'block',
    overflowY: 'auto',
  },
  previewImage: {
    maxWidth: '100%',
    height: 'auto',
  },
  closeIcon: {
    '&& > button': {
      position: 'absolute',
      right: 0,
      top: `-${theme.spacing.unit * 5}px`,
    },
    '&& > button > svg': {
      color: theme.palette.text.white,
      fontSize: '2.5rem',
      width: 40,
      height: 40,
    },
  },
});

export default styles;
